const COPYABLE_FIELD_TYPES = new Set([
  "PDFTextField",
  "PDFCheckBox",
  "PDFRadioGroup",
]);

export const isCopyableField = (field) => COPYABLE_FIELD_TYPES.has(field?.type);

export const getSelectedCopyableFields = (tempFields = {}) => {
  const selectedFields = [
    tempFields?.selectedFormField,
    ...(Array.isArray(tempFields?.selectedExtraFields)
      ? tempFields.selectedExtraFields
      : []),
  ];
  const seenNames = new Set();

  return selectedFields.filter((field) => {
    if (!isCopyableField(field)) return false;

    const identity = field?.name;
    if (!identity || seenNames.has(identity)) return false;

    seenNames.add(identity);
    return true;
  });
};

export const copySelectedFieldGeometry = (tempFields, fallbackPage) =>
  getSelectedCopyableFields(tempFields).map((field) => ({
    x: Number(field?.x) || 0,
    y: Number(field?.y) || 0,
    width: Number(field?.width) || 0,
    height: Number(field?.height) || 0,
    page: field?.page ?? field?.page_num ?? fallbackPage,
    type: field?.type,
  }));

export const duplicateCopiedFields = ({
  copiedFields = [],
  existingFields = [],
  fallbackPage,
  createName,
}) => {
  const maxOrder = Math.max(
    0,
    ...existingFields.map((field) => Number(field?.order) || 0),
  );

  return copiedFields.filter(isCopyableField).map((copiedField, index) => {
    const generatedName = createName();
    const baseField = {
      name: generatedName,
      field_label: generatedName,
      label: generatedName,
      type: copiedField.type,
      x: copiedField.x,
      y: copiedField.y,
      width: copiedField.width,
      height: copiedField.height,
      page: copiedField.page ?? fallbackPage,
      order: maxOrder + index + 1,
    };

    return copiedField.type === "PDFCheckBox" ||
      copiedField.type === "PDFRadioGroup"
      ? { ...baseField, value: false }
      : {
          ...baseField,
          value: "",
          fontSize: 10,
          fontSizes: [],
          autoFontSize: true,
        };
  });
};
